/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.13.0
 */

import styled from 'styled-components';

import { IAttrStyled } from '../../../../types/globalTypes';

export const SubscriberIdStatusStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `subscriber-id-status ${className || ''}`,
}))`
    .subscriber-id-status__lock-date {
        margin-top: 8px;
    }

    .status__content {
        margin-top: 16px;
    }
`;
